const projects = [
  {
    id: "ai-resume-maker",
    links: {
      github: "https://github.com/dankevil/Portify",
      live: "http://72.61.232.47/",
    },
    techs: ["next", "ts", "mongo"],
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "shopassist-ai",
    links: {
      github: "dankevil/ShopAssistAI",
    },
    techs: ["react", "node", "postgreSql"],
    hasImage: true,
    imgExtension: "jpg"
  },
  {
    id: "smartbuilder-ai",
    links: {
      github: "dankevil/smartbuilder-2.0-vendure",
    },
    techs: ["react", "node", "express", "mongo"],
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "ai-business-planner",
    links: {
      github: "dankevil/bplannernew",
    },
    techs: ["react", "fastapi", "python"],
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "youtube-shorts-generator",
    techs: ["python", "streamlit"],
    links: {
      github: "https://github.com/dankevil/YT-shorts-Generator-AI",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "genusinnovation",
    techs: ["wordpress", "php"],
    links: {
      live: "www.genusinnovation.com",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "dobiee",
    techs: ["wordpress", "woocommerce", "php"],
    links: {
      live: "dobiee.com",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "sahayatha-healthcare",
    techs: ["wordpress", "php"],
    links: {
      live: "sahayathahealthcare.com",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "solisclean",
    techs: ["wordpress", "php"],
    links: {
      live: "solisclean.in",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "a1fitline",
    techs: ["wordpress", "php"],
    links: {
      live: "a1fitline.com",
    },
    hasImage: true,
    imgExtension: "png",
  },
  {
    id: "sthanadecor",
    techs: ["wordpress", "php"],
    links: {
      live: "sthanadecor.com",
    },
    hasImage: true,
    imgExtension: "png",
  },

  {
    id: "laceon",
    techs: ["shopify", "liquid"],
    links: {
      live: "laceon.in",
    },
    hasImage: true,
    imgExtension: "png",
  },

  {
    id: "zigweb",
    techs: ["wordpress", "php"],
    links: {
      live: "zigweb.com",
    },
    isSmall: true,
  },
  {
    id: "crack-ed",
    techs: ["wordpress", "php"],
    links: {
      live: "crack-ed.com",
    },
    isSmall: true,
  },
  {
    id: "nightcap-club",
    techs: ["shopify", "liquid"],
    links: {
      live: "nightcap.club",
    },
    isSmall: true,
  },
  {
    id: "proxy-checker",
    techs: ["ts", "node"],
    links: {
      github: "dankevil/Proxy-checker",
    },
    isSmall: true,
  },
  {
    id: "float-motivation",
    techs: ["python"],
    links: {
      github: "dankevil/float-motivation",
    },
    isSmall: true,
  },
];

export default projects;
